import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import styles from './zoom-level.module.css'

export default function ZoomLevel({ zoomLevel }) {
    return (
        <div className={styles.container}>
            Zoom level: {zoomLevel}
        </div>
    );
}

ZoomLevel.propTypes = {
    zoomLevel: PropTypes.number.isRequired
};